require('./receivedTransfersContentTable.scss');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');

// @ commons
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const TransfersTableRow = require('components/transfers/transfersTableRow/transfersTableRow');
const { TransfersTableInfoRow } = require('components/transfers/transfersTableInfoRow/transfersTableInfoRow');

// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

const TABLE_COLUMNS_CC = 7;
const TABLE_COLUMNS = 5;
const TABLE_COLUMNS_MOBILE = 2;


class ReceivedTransfersContentTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expandedRowId: '' };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
    }

    buildNextPageButton() {
        const { immAccountReceivedTransfers } = this.props;
        let buttonContent;
        if (immAccountReceivedTransfers.get('nextPage')) {
            if (immAccountReceivedTransfers.get('loadingNextPage')) {
                buttonContent = <LoadingSection />;
            }
            else {
                buttonContent = (
                    <div className="received-transfers-content-table__more-movements">
                        <OKButton modifier="link-complementary" onClick={this.handleNextPage}>
                            <FormattedText value="transfersReceived-seeMore" />
                        </OKButton>
                    </div>
                );
            }
        }
        return buttonContent;
    }

    handleNextPage(){
        const { accountId, requestReceivedTransfersNextPage } = this.props;
        requestReceivedTransfersNextPage(accountId);
    }

    handleRowClick(rowId) {
        this.setState({
            expandedRowId: (rowId === this.state.expandedRowId) ? '' : rowId
        })
    }

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHead;

        if (immScreen.get('isMobile')) {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true} className="received-transfers-content-table__table-header-row-line">
                        <OKTableCell
                            asHeader={true}
                            className="received-transfers-content-table__table-header-cell-line"
                        />
                    </OKTableRow>
                </thead>
            );
        } else {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true} className="received-transfers-content-table__header-cell">
                            <span></span>
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="received-transfers-content-table__header-cell">
                            <FormattedText value="transfersReceived-date" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="received-transfers-content-table__header-cell">
                            <FormattedText value="transfersLanding-emiter" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="received-transfers-content-table__header-cell">
                            <FormattedText value="transfersLanding-concept" format="uppercase" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="received-transfers-content-table__header-cell--right">
                            <FormattedText value="transfersLanding-amount" format="uppercase" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            );
        }
        
        return tableHead;
    }

    render() {
        const { immAccountReceivedTransfers, immScreen } = this.props;
        const immAccountReceivedTransfersByOrder = immAccountReceivedTransfers.get('byOrder');
        const immAccountReceivedTransfersById = immAccountReceivedTransfers.get('byId');
        const { expandedRowId } = this.state;
        const nextPageButton = this.buildNextPageButton();
        const tableHead = this.buildTableHead();
        const tableColumns = (immScreen.get('isMobile')) ? TABLE_COLUMNS_MOBILE : (__CONTACT_CENTER__) ? TABLE_COLUMNS_CC : TABLE_COLUMNS;

        return (
            <div className="received-transfers-content-table">
                <LastMovementsTable
                    groupByDate={true}
                    rowComponent={TransfersTableRow}
                    immTransactionsByOrder={immAccountReceivedTransfersByOrder}
                    immTransactionsById={immAccountReceivedTransfersById}
                    columnsCount={tableColumns}
                    expandedRowId={expandedRowId}
                    expandedRowComponent={TransfersTableInfoRow}
                    onRowClick={this.handleRowClick}
                    id="received-transfers-table"
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    {tableHead}
                </LastMovementsTable>
                {nextPageButton}
            </div>
        );
    }
}

ReceivedTransfersContentTable.propTypes = {
    accountId: PropTypes.string.isRequired,
    immAccountReceivedTransfers: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    requestReceivedTransfersNextPage: PropTypes.func.isRequired
};

module.exports = ReceivedTransfersContentTable;
